import TextInput from 'components/_other/form/TextInput';

import styles from 'app/components/category/parameters/categoryElements/CategoryElementPrice.module.scss';
import get from 'lodash/get';

import toNumber from 'lodash/toNumber';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { getTrackBackground, Range } from 'react-range';
import omit from 'lodash/omit';
import { getFilterUrl } from '@/utils/filter';
import isFunction from 'lodash/isFunction';

const CategoryElementPrice = ({
  selected,
  options = {},
  afterSelected,
  category,
  selectedParams,
  getUrl,
}) => {
  const router = useRouter();
  const { headline = '' } = options;

  let slider = {
    min: get(options, 'min', 0),
    max: get(options, 'max'),
    selected: [],
  };

  const [sliderValues, setSliderValues] = useState({
    min:
      get(selected, 'min', slider.min) < slider?.min
        ? slider?.min
        : selected?.min,
    max:
      get(selected, 'max', slider.max) > slider?.max
        ? slider?.max
        : selected?.max,
  });

  // build new url and push to router
  const applyFilter = (paramKey, paramValues) => {
    const isActive = !!selectedParams[paramKey];
    const url = isFunction(getUrl)
      ? getUrl(paramKey, paramValues)
      : getFilterUrl(
          selectedParams,
          paramKey,
          paramValues,
          false,
        true,
        false
        );

    router.push(url.pathname, { scroll: false });
  };

  const handleChange = e => {
    e.preventDefault();
    const valueName = e.target.name === 'priceTo' ? 'max' : 'min';
    setSliderValues({
      ...sliderValues,
      ...{ [valueName]: toNumber(e.target.value) },
    });
  };

  const handleSliderChange = ([min, max]) => {
    setSliderValues({
      min: min,
      max: max,
    });
  };

  const handleSubmit = (minValue, maxValue) => {
    let min = minValue;
    let max = maxValue;

    if (min > max) {
      min = maxValue;
      max = minValue;
    }

    // create range if values are the same
    if (min === max) {
      if (max === slider?.max) {
        min = min - 1;
      } else {
        max = max + 1;
      }
    }

    if (selected.min !== min || selected.max !== max) {
      applyFilter('cena', [Math.abs(min), Math.abs(max)]);
    }
    afterSelected?.();
  };

  const handleInputSubmit = e => {
    e.preventDefault();
    handleSubmit(sliderValues.min, sliderValues.max);
  };

  const handleSliderSubmit = ([min, max]) => {
    handleSubmit(min, max);
  };

  const handleKeyPress = e => {
    // on enter press
    if (e.keyCode === 13) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <>
      {headline ? headline : <h3>Cena</h3>}
      {slider?.min != slider?.max ? (
        <>
          <div className={styles?.prices}>
            <div className={styles?.inputWrap}>
              <TextInput
                small
                label={'od'}
                hasFeedback={false}
                inputProps={{
                  groupClassName: styles.inputInner,
                  name: 'priceFrom',
                  value: sliderValues.min,
                  onChange: handleChange,
                  onBlur: handleInputSubmit,
                  onKeyDown: handleKeyPress,
                }}
              />
            </div>
            <div className={styles?.inputWrap}>
              <TextInput
                small
                label={'do'}
                hasFeedback={false}
                inputProps={{
                  groupClassName: styles.inputInner,
                  name: 'priceTo',
                  value: sliderValues.max,
                  onChange: handleChange,
                  onBlur: handleInputSubmit,
                  onKeyDown: handleKeyPress,
                }}
              />
            </div>
          </div>
          {slider?.min < slider?.max ? (
            <div className={styles?.rangeSlider}>
              <Range
                step={1}
                min={slider.min}
                max={slider.max}
                values={[sliderValues.min, sliderValues.max]}
                onChange={handleSliderChange}
                onFinalChange={handleSliderSubmit}
                allowOverlap={false}
                renderTrack={({ props, children }) => (
                  <div
                    className={styles?.track}
                    onMouseDown={props.onMouseDown}
                    onTouchStart={props.onTouchStart}
                  >
                    <div
                      className={styles?.activeTrack}
                      ref={props.ref}
                      style={{
                        background: getTrackBackground({
                          values: [sliderValues.min, sliderValues.max],
                          colors: [
                            'rgb(0, 0, 0)',
                            'rgb(0, 0, 0)',
                            'rgb(0, 0, 0)',
                          ],
                          min: slider.min,
                          max: slider.max,
                        }),
                      }}
                    >
                      {children}
                    </div>
                  </div>
                )}
                renderThumb={({ props, isDragged }) => {
                  const realProps = omit(props, ['key']);

                  return (
                    <div
                      className={styles?.thumb}
                      key={`thumb-key-${props.key}`}
                      {...realProps}
                    >
                      <span
                        className={`${styles?.thumbInner} ${
                          isDragged ? styles?.active : null
                        }`}
                      />
                      <span
                        className={`${styles?.thumbInner} ${
                          isDragged ? styles?.active : null
                        }`}
                      />
                      <span
                        className={`${styles?.thumbInner} ${
                          isDragged ? styles?.active : null
                        }`}
                      />
                    </div>
                  );
                }}
              />
            </div>
          ) : null}
        </>
      ) : (
        <span>
          všetko v hodnote <b>{slider?.max} &euro;</b>
        </span>
      )}
    </>
  );
};

export default CategoryElementPrice;
